import { useServiceFeeEnabled } from 'Components/transactionFees/hooks/useServiceFeeEnabled';

import { DealerDetails } from '../DealerDetails/DealerDetails';
import { PaymentDetails } from '../PaymentDetails/PaymentDetails';
import { SaleDetails } from '../SaleDetails/SaleDetails';

import styles from './SaleDetailsView.scss';

export const SaleDetailsView = () => {
  const { isServiceFeeEnabled } = useServiceFeeEnabled();

  return (
    <div className={styles.saleDetailsView} data-service-fee={isServiceFeeEnabled || undefined}>
      <SaleDetails />
      <DealerDetails />

      { !isServiceFeeEnabled && <PaymentDetails /> }
    </div>
  );
};
